export default "__VITE_ASSET__D_1zEFnp__"